import { createReducer, on } from '@ngrx/store';
import * as StopVmixServerActions from '../actions/stop-vmix-server.actions';
import {ProductionInstance} from '../../../services/api/production-instances/production-instance.model';

export const stopVmixServerFeatureKey = 'stopVmixServer';

export interface State {
  record: ProductionInstance | null;
  error: any | null;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false,
};


export const reducer = createReducer(
  initialState,

  on(StopVmixServerActions.stopVmixServer, (state) => ({
    ...state,
    error: null,
    loaded: false,
    loading: true,
  })),
  on(StopVmixServerActions.stopVmixServerSuccess, (state, action) => ({
    record: action.data,
    error: null,
    loaded: true,
    loading: false,
  })),
  on(StopVmixServerActions.stopVmixServerFailure, (state, action) => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false,
  })),
  on(StopVmixServerActions.clearStopVmixServerState, () => ({
    record: null,
    error: null,
    loaded: false,
    loading: false,
  })),
);

